<template>
  <div class="content-editable d-flex flex-column">
    <template v-if="type === 'STRING'">
      <b-form-textarea v-if="edit" :placeholder="placeholder" ref="stringInput" :value="value" @input="onInput"/>
      <p v-else-if="typeof value === 'string' && value.length">{{ value }}</p>
      <p v-else class="text-muted">{{ placeholder }}</p>
    </template>
    <template v-if="type === 'EMAIL'">
      <b-form-input v-if="edit" :placeholder="placeholder" ref="stringInput" type="email" :value="value" @input="onInput"/>
      <p v-else-if="typeof value === 'string' && value.length">{{ value }}</p>
      <p v-else class="text-muted">{{ placeholder }}</p>
    </template>
    <div class="d-flex flex-row">
      <template v-if="edit">
        <b-button class="text-success text-decoration-none p-0 mr-2" @click="onSave" variant="link">
          <small><strong>Save</strong></small>
        </b-button>
        <b-button class="text-danger text-decoration-none p-0" @click="onCancel" variant="link">
          <small>Cancel</small>
        </b-button>
      </template>
      <b-button class="text-muted text-decoration-none p-0" @click="onEdit" v-else variant="link">
        <small><strong>Edit</strong></small>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: '(None)',
    },
    type: {
      type: String,
      default: 'STRING',
      validate: type => [ 'STRING', 'EMAIL' ].includes(type),
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      edit: false,
      previous: this.value,
    };
  },
  methods: {
    onEdit() {
      this.edit = true;
      this.$nextTick(() => {
        const { stringInput } = this.$refs;
        if (stringInput) {
          stringInput.focus();
        }
      });
    },
    onInput(value) {
      this.$emit('input', value);
    },
    onSave() {
      this.$emit('saved', this.value);
      this.edit = false;
      this.previous = this.value;
    },
    onCancel() {
      this.onInput(this.previous);
      this.$emit('cancelled', this.previous);
      this.edit = false;
    },
  },
};
</script>

<style lang="scss">
.content-editable {
  .form-control {
    border: none;
    color: #212529;
    height: inherit;
    font-size: 0.9rem;
    letter-spacing: 0.02em;
    line-height: 1.8;
    margin: 0;
    outline: 0px solid transparent;
    padding: 0;
  }

  p {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/misc/ContentEditable.vue